import { Header } from '../../components/Header/Header';
import './Info.css';

export const Info = (props) => {
  const { cdn } = props;

  const telTo = () => {
    window.location.href = 'tel:0176625091';
  };

  const mailTo = () => {
    window.location.href = 'mailto:jerome.soulages2@abeille-assurances.fr';
  };

  return (
    <div className="page info-page">
      <Header cdn={cdn} btn="back" />
      <div className="info-page__content">
        <div className="info-page__content__head">
          <div className="info-page__content__head__title">MONTAIGNE</div>
          <div className="info-page__content__head__address">
            80 av. de l'europe - 92270 Bois Colombes
          </div>
          <div className="info-page__content__head__sub-title">Service d'accompagnement</div>
        </div>
        <div className="info-page__content__banner">
          <div className="info-page__content__banner__tel" onClick={telTo}>
            <div className="info-page__content__banner__tel__icn">
              <img
                className="info-page__content__banner__tel__icn__img"
                alt="Phone icon"
                src={`${cdn}pictos/phone.svg`}
              />
            </div>
            <div className="info-page__content__banner__tel__text">07 76 19 36 04</div>
          </div>
          <div className="info-page__content__banner__mail" onClick={mailTo}>
            <div className="info-page__content__banner__mail__icn">
              <img
                className="info-page__content__banner__mail__icn__img"
                alt="Mail icon"
                src={`${cdn}pictos/mail.svg`}
              />
            </div>
            <div className="info-page__content__banner__mail__text">
              service_accompagnement@abeille-assurances.fr
            </div>
          </div>
        </div>
        <div className="info-page__content__sections">
          <div className="info-page__content__sections__section">
            <div className="info-page__content__sections__section__title">Édition</div>
            <div className="info-page__content__sections__section__item">
              <div className="info-page__content__sections__section__item__bold">
                Dénomination et forme sociale :
              </div>
              Qr design S.A.S. Société par action simplifiée
            </div>
            <div className="info-page__content__sections__section__item">
              <div className="info-page__content__sections__section__item__bold">Capital social :</div>
              10 000 €
            </div>
            <div className="info-page__content__sections__section__item">
              <div className="info-page__content__sections__section__item__bold">Siège social :</div>9 av.
              Gambetta - 24160 Excideuil - France
            </div>
            <div className="info-page__content__sections__section__item">
              <div className="info-page__content__sections__section__item__bold">Immatriculation :</div>
              794 060 905 000 13 - R.C.S. PÉRIGUEUX
            </div>
          </div>
          <div className="info-page__content__sections__section">
            <div className="info-page__content__sections__section__title">Conception</div>
            <div className="info-page__content__sections__section__item">
              Propriétés intellectuelle, industrielle&nbsp;et&nbsp;commerciale&nbsp;®2024
            </div>
            <div className="info-page__content__sections__section__item">
              <div className="info-page__content__sections__section__item__bold">
                Conception - Développement et programmation :
              </div>
              Rémi MALOBERTI
            </div>
            <div className="info-page__content__sections__section__item">
              <div className="info-page__content__sections__section__item__bold">
                Conception - Responsable de la publication :
              </div>
              Benjamin JEAN - Qr Design S.A.S.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
